import React, { useState, useEffect } from "react";
import DynamicTable from "@atlaskit/dynamic-table";
import { useDispatch } from "react-redux";
import uuid from "react-uuid";
import DeleteIcon from "@atlaskit/icon/core/delete";
import Button from "@atlaskit/button/new";
import { flowVarTableHeaders } from "../../../../../../../common/constants/core/integration.constants";
import {
  setEditorSaved,
} from "../../../../../../../redux/actions/integrationActions";
import CellTextField from "../../../../../../../common/components/CellTextField";
import Select from "@atlaskit/select";
import {
  getDynFlowVarIntro,
} from "./DynamicFlowVarHelperText";
import {FlowVariableBehavior} from "../../../../../../../common/interfaces/flow/variable/FlowVariable"
import EmptyState from "@atlaskit/empty-state";
import { Inline } from "@atlaskit/primitives";
import AddIcon from "@atlaskit/icon/core/add";
const DynamicFlowVariablePanel = ({ action }) => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const behaviorOptions = [
    { label: "Set", value: FlowVariableBehavior.SET },
    { label: "Set for each", value: FlowVariableBehavior.SET_FOR_EACH },
    { label: "Append", value: FlowVariableBehavior.APPEND },
    { label: "Append for each", value: FlowVariableBehavior.APPEND_FOR_EACH },
  ];

  useEffect(() => {
    if (action?.flowVariables) {
      setRows(getRows());
    } else {
      setRows([]);
    }
  }, [action]);

  const createRow = (item, index) => ({
    cells: [
      {
        content: (
          <CellTextField
            inputValue={item.name}
            index={index}
            onChange={onChangeHeader}
            type="KEY"
          />
        ),
        key: uuid(),
      },
      {
        content: (
          <CellTextField
            inputValue={item.value}
            index={index}
            onChange={onChangeHeader}
            type="VALUE"
          />
        ),
        key: uuid(),
      },
      {
        content: (
          <Select
            options={behaviorOptions}
            value={behaviorOptions.find((o) => o.value === item.behavior)}
            spacing="compact"
            onChange={(val) => onChangeBehavior(val, index)}
            name="behaviorPicker"
          />
        ),
        key: uuid(),
      },
      {
        content: (
        
          <CellTextField
            inputValue={item.instruction}
            index={index}
            onChange={onChangeHeader}
            type="INSTRUCTION"
            isDisabled={item.behavior === FlowVariableBehavior.APPEND 
              || item.behavior === FlowVariableBehavior.SET}
          />
          
        ),
        key: uuid(),
      },
      {
        content: getButton(index),
        key: uuid(),
      },
    ],
  });
  const getButton = (index) => {
    return (
      <Button
        onClick={() => onRemoveHeader(index)}
        iconBefore={DeleteIcon}
        aria-label="Remove Header"
      />
    );
  };
  const onChangeHeader = (value, index, type) => {
    switch (type) {
      case "KEY":
        action.flowVariables[index].name = value;
        break;
      case "VALUE":
        action.flowVariables[index].value = value;
        break;
      case "INSTRUCTION":
        action.flowVariables[index].instruction = value;
        break;
      default:
        break;
    }
    dispatch(setEditorSaved(false));
  };
  const onChangeBehavior = (option, index) => {
    action.flowVariables[index].behavior = option.value;
    dispatch(setEditorSaved(false));
    setRows(getRows()); //run this due to refresh issue
  };
  const getRows = () => {
    if (action?.flowVariables) {
      return action.flowVariables.map((h, i) => {
        return createRow(h, i);
      });
    }
    return [];
  };
  const onAddHeader = () => {
    action.flowVariables
      ? action.flowVariables.push({
          name: "",
          value: "",
          behavior: FlowVariableBehavior.SET,
          instruction: "",
        })
      : (action.flowVariables = [
          { name: "", value: "", behavior: FlowVariableBehavior.SET,instruction: "" },
        ]);
    setRows(getRows());
    dispatch(setEditorSaved(false));
  };
  const onRemoveHeader = (index) => {
    if (index > -1) {
      action.flowVariables.splice(index, 1);
      setRows(getRows());
      dispatch(setEditorSaved(false));
    }
  };

  return (
    <>
      {getDynFlowVarIntro()}
      <br />
      <Inline alignBlock="center" spread="space-between">
        <b>Post-Request Variables</b>        
          <div className="ihub-sidebar-action-widget-add-action" onClick={onAddHeader}>
            <AddIcon label="" />
              <div className="ihub-sidebar-action-widget-add-action-text">
                Add
              </div>
          </div>
      </Inline>
      <DynamicTable head={flowVarTableHeaders} rows={rows ? rows : []} />
      {rows.length === 0 && <EmptyState description="There is no Post-Request variables defined yet." />}
    </>
  );
};

export default DynamicFlowVariablePanel;
